module.exports = __webpack_public_path__ + "img/aboutNews1.12bf5147.png";